import { FOCUS_INTERACTION_COMPONENT_IDS as FOCUS_INTERACTION_COMPONENT_ID_LIST } from '../constants/focus-interaction-component-ids';

export type InteractionDomEventType =
  | 'click'
  | 'change'
  | 'focusin'
  | 'focusout';

const FOCUS_INTERACTION_COMPONENT_IDS: ReadonlySet<string> = new Set(
  FOCUS_INTERACTION_COMPONENT_ID_LIST,
);

export function shouldDispatchInteractionForDomEvent(
  domEventType: InteractionDomEventType,
  componentId: string,
): boolean {
  if (domEventType === 'click' || domEventType === 'change') {
    return true;
  }

  if (domEventType === 'focusin' || domEventType === 'focusout') {
    return FOCUS_INTERACTION_COMPONENT_IDS.has(componentId);
  }

  return false;
}
